import tracking from 'dibs-tracking';

export const LOCATION_PDP = 'pdp';
export const LOCATION_SEARCH_BROWSE = 'search/browse';

export function trackFavoriteTooltipClicked(location) {
    tracking.trackEvent({
        category: 'trade onboarding',
        action: 'tooltip displayed',
        label: `${location} - item favorited`,
    });
}

export function trackFavoriteTooltipSourcingHelpClicked(location) {
    tracking.trackEvent({
        category: 'trade onboarding',
        action: 'sourcing help link clicked',
        label: `${location} - item favorited`,
    });
}
